<div [class]="isMobile ? '' : 'booble-backdrop'">
  <div [class]="isMobile ? '' : 'xp-modal xp-modal-cadastro'">
    <div
      [class]="
        isMobile
          ? ''
          : 'modal-dialog modal-xl modal-dialog-centered modal--xl modal--lg modal--md modal--sm'
      "
    >
      <div [class]="isMobile ? '' : 'modal-content'">
        <div [class]="isMobile ? '' : 'modal-dialog-scrollable-general'">
          <div class="modal-header">
            <div
              class="col-md-12 d-flex justify-content-between modal-header-border"
            >
              <div>
                <div class="modal-title-new">Conta para recebimento</div>
                <p class="p-text-grey font-weight-400 mg-top-8">
                  Selecione uma conta bancária para recebimento dos reais no
                  Brasil.
                </p>
              </div>

              <div
                (click)="closeModal()"
                class="close-icon tappable align-self-center"
              >
                <img src="assets/image/close-modal-icon.svg" />
              </div>
            </div>
          </div>

          <div class="modal-body">
            <div [class]="isMobile ? '' : 'container-modal'" class="mg-top-24">
              <div class="d-flex justify-content-between">
                <span class="title-form"> Contas cadastradas </span>
                <p
                  *ngIf="accounts.length > 0"
                  class="tappable label-action"
                  (click)="openAddBankAccountModal()"
                >
                  Adicionar conta
                </p>
              </div>

              <div
                *ngIf="accounts.length == 0"
                class="no-accounts-container mg-top-24 d-flex flex-column align-items-center justify-content-center"
              >
                <img
                  src="assets/icons/no-account.svg"
                  alt="Nenhuma conta bancária"
                  class="no-accounts-icon"
                />
                <p class="no-accounts-message">
                  Nenhuma conta bancária cadastrada.
                </p>
                <p
                  (click)="openAddBankAccountModal()"
                  class="tappable label-action mt-3"
                >
                  Adicionar conta
                </p>
              </div>

              <div
                *ngIf="accounts && accounts.length > 0"
                class="card-content mg-top-24"
              >
                <div class="card-container" *ngFor="let account of accounts">
                  <div
                    class="card card-hover"
                    [ngClass]="{ active: selectedAccount === account }"
                    (mouseenter)="hovered = account"
                    (mouseleave)="hovered = null"
                    (click)="selectAccount(account)"
                  >
                    <div class="d-flex list-bank align-items-center p-3">
                      <mat-radio-group class="radios-btns">
                        <mat-radio-button
                          class="radio-button radio-list custom-radio-button"
                          [checked]="selectedAccount === account"
                          [value]="true"
                        >
                        </mat-radio-button>
                      </mat-radio-group>
                      <div class="d-flex align-items-center gap-8">
                        <mat-icon>account_balance</mat-icon>

                        <div class="ml-3">
                          <div class="bank-name p-text-grey-dark">
                            {{ account.number }} - {{ account.name }}
                          </div>
                          <div class="bank-details">
                            <span> Agência {{ account.agency }} </span>

                            <span> Conta {{ account.number }} </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer-new">
            <button
              [disabled]="!selectedAccount || loading"
              (click)="sendAccountInbound()"
              type="button"
              class="btn-footer btn btn-block"
              [ngClass]="
                companyId ? 'btn-dark-primary-blue' : 'btn-dark-primary-blue-pf'
              "
              type="button"
            >
              Selecionar conta
              <span
                class="spinner-border spinner-border-sm"
                *ngIf="loading"
              ></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
